import { Button, Divider, FormControl, Modal, Stack, Typography } from "@mui/material";
import React from "react";

import DataGrid from "../../../../components/DataGrid/DataGrid";
import { ISpreadsheetGrid } from "../../../../components/Spreadsheet/ISpreadsheetGrid";
import { InvestorCommitment, Workbook } from "../../../../utils/types/workbook.type";
import { useInvestorIdReconcilerEffect } from "./InvestorIdReconciler.hooks";
import { StyledBox } from "./InvestorIdReconciler.styles";

type InvestorIdReconcilerProps = {
    workbook: Workbook, 
    investorCommitments: InvestorCommitment[],
    grid: ISpreadsheetGrid,
    onSave: () => void,
    onCancel: () => void
};

export const InvestorIdReconciler: React.FC<InvestorIdReconcilerProps> = ({
  workbook, investorCommitments, grid, onSave, onCancel
}) => {

    const {
        hasInvestorNameChanges,
        headerList,
        getGridRows,
        isFormValid,
        handleSave
    } = useInvestorIdReconcilerEffect(workbook, investorCommitments, grid, onSave);

    if(!hasInvestorNameChanges) return null;

    return (
        <>
            <Modal
                open={true}
                onClose={onCancel}
                id="mdl_new_transaction"
                aria-labelledby="modal_newtranstype_title"
                aria-describedby="modal_newtranstype_description"
            >
                <StyledBox>
                <Typography id="modal_newtranstype_title" component="h2">
                    Confirm Investor Changes
                </Typography>
                <Typography id="modal_newtranstype_description" variant='body2'>
                    Investor changes have been made that need to apply to this workbook. Please provide more detail on the Investor change, so the workbook can be calculated properly. If this is a new Investor, mark the change as "New". If this is an Investor rename, mark the change as "Rename" and select the old Investor name in the "Renamed From" column.
                </Typography>

                <Divider />

                <DataGrid
                    id="data_grid"
                    headerList={headerList}
                    dataList={getGridRows()}
                    checkboxSelection={false}
                    autoHeight={false}
                    minHeight="300px"
                />

                <FormControl>
                    <Stack direction="row" justifyContent={"end"} spacing={4} sx={{ mt: 3 }}>
                    <Button id="btn_submit" variant="outlined" disabled={!isFormValid()} onClick={handleSave}>Save</Button>
                    <Button id="btn_cancel_save" variant="outlined" onClick={ onCancel }>Cancel</Button>
                    </Stack>
                </FormControl>
                </StyledBox>
            </Modal>
        </>
  );
};